<div class="SAS_Navbar">
  <!-- Header -->
    <!-- <section class="about-jtc top-background no-printme">
        <div class="background-image">
        </div>
    </section> -->

    <div class="intro2">
      <div class="container-fluid">
        <!-- Our Services -->
        <div class="OurServices">
         

          <div class="row ServiceCollection text-white justify-content-around">

            <!-- (click)="showPatientRecord('مقدمة عن المنصة العلاجية.mp4')" -->
            <div class="col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl">
              <h3 class="text-center font-size-20 mb-3" style="min-height: 50px;">تعريف التلعثم/ التأتأة </h3>
              <div class="icon-container flex justfy-center">
                <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
                <div class="video-container">
                  <video width="300"  controls style="border-radius:10px ; width: 100%; height: auto;">
                    <source src="https://mcsc-saudi.com/api/media/Introduction.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>

            <!-- (click)="showPatientRecord('مقدمة عن المنصة العلاجية.mp4')" -->
            <div class="col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl">
              <h3 class="text-center font-size-20 mb-3" style="min-height: 50px;">مقدمة عن المنصة العلاجية</h3>
              <div class="icon-container flex justfy-center">
                <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
                <div class="video-container">
                  <video width="300"  controls style="border-radius:10px ; width: 100%; height: auto;">
                    <source src="../../../assets/videos/مقدمة عن المنصة العلاجية.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>

            <!-- (click)="showPatientRecord('الاسس التي بني عليها البرنامج العلاجي.mp4')" -->
            <div class="col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl" >
              <h3 class="text-center font-size-20 mb-3" style="min-height: 50px;">الاسس التي بني عليها البرنامج العلاجي</h3>
              <div class="icon-container flex justfy-center">
                <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
                <div class="video-container">
                  <video width="300"  controls style="border-radius:10px ; width: 100%; height: auto;">
                    <source src="../../../assets/videos/الاسس التي بني عليها البرنامج العلاجي.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>

            <!-- (click)="showPatientRecord('كيفية الاشتراك في المنصة.mp4')" -->
            <div class="col-md-4 service bg-site-color py-3 mb-1 border-left-1 pointer border-raduis-br-bl" >
              <h3 class="text-center font-size-20 mb-3" style="min-height: 50px;">كيفية الاشتراك في المنصة</h3>
              <div class="icon-container flex justfy-center">
                <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
                <div class="video-container">
                  <video width="300"  controls style="border-radius:10px ; width: 100%; height: auto;">
                    <source src="../../../assets/videos/كيفية الاشتراك في المنصة.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>

            <!-- (click)="showPatientRecord('مرحلة التشخيص.mp4')" -->
            <div class="col-md-4 service py-3 mb-1 bg-site-color border-left-1 pointer border-raduis-br-bl" >
              <h3 class="text-center font-size-20 mb-3" style="min-height: 50px;">مرحلة التشخيص</h3>
              <div class="icon-container flex justfy-center">
                <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
                <div class="video-container">
                  <video width="300"  controls style="border-radius:10px ; width: 100%; height: auto;">
                    <source src="../../../assets/videos/مرحلة التشخيص.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>

            <!-- (click)="showPatientRecord('مرحلة الجلسات العلاجية.mp4')" -->
            <div class="col-md-4 service py-3 mb-1 bg-site-color border-left-1 pointer border-raduis-br-bl" >
              <h3 class="text-center font-size-20 mb-3" style="min-height: 50px;">مرحلة الجلسات العلاجية</h3>
              <div class="icon-container flex justfy-center">
                <!-- <i class="fas fa-play-circle fa-7x icon-rounded"></i> -->
                <div class="video-container">
                  <video width="300"  controls style="border-radius:10px ; width: 100%; height: auto;">
                    <source src="../../../assets/videos/مرحلة الجلسات العلاجية.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>

          </div>
          </div>

        </div>

    </div>

  <!-- Footer -->
  <!-- <app-outer-pages-footer></app-outer-pages-footer> -->

</div>
